import { createSlice } from "@reduxjs/toolkit";

const accidentSlice = createSlice({
    name: "accident",
    initialState: {
        accidents: [],
        lastAccident:null,
        lastPartner:null,
        numberOfAccidents: 0,  
        numberOfAuftrage: 0,  
        partner: null,
        getLoading: false,
        createLoading:false,
        createPhotoLoading:false,
    },
    reducers: {
        setAccidents(state, action) {
            state.accidents = action.payload;
        },
        setNumberOfAccident(state, action) {
            state.numberOfAccidents = action.payload;
        },
        setNumberOfAuftrage(state, action) {
            state.numberOfAuftrage = action.payload;
        },
        setGetLoading(state, action){
            state.getLoading = action.payload;
        },
        setCreateLoading(state, action) {
            state.createLoading = action.payload;
        },
        setCreatePhotoLoading(state, action) {
            state.createPhotoLoading = action.payload;
        },
        setLastAccident(state, action){
            state.lastAccident = action.payload
        }
        ,
        setPartner(state, action) {
            state.partner = action.payload;
        },
        setLastPartner(state, action){
            state.lastPartner = action.payload
        }
        ,
        addPhotoToLastAccident(state, action) {
            if (!state.lastAccident.photos) {
                state.lastAccident.photos = [];  // Ensure photos array exists
            }
            state.lastAccident.photos.unshift(action.payload); // Add the new photo
        },
        addPhotoToPartner(state, action) {
            if (!state.partner.user.photos) {
                state.partner.user = [];  // Ensure photos array exists
            }
            state.partner.user.photos.unshift(action.payload); // Add the new photo
        },
        removeAccident(state, action) {
            console.log(state.accidents);
            state.accidents.accidents = state.accidents.accidents.filter(acc => acc._id !== action.payload);
          },
          addHochladenPhoto (state, action){
            state.lastAccident.hochladen.unshift(action.payload); // Add to the beginning of the array
          },
          addHochladenPhotoToPartner (state, action){
            state.partner.user.hochladen.unshift(action.payload); // Add to the beginning of the array
          },
          removeHochladenPhoto(state, action) {
            state.lastAccident.hochladen = state.lastAccident.hochladen.filter(photo => photo._id !== action.payload);
        },
        removeHochladenPhotoFromPartner(state, action) {
          console.log(action.payload);
          
            state.partner.user.hochladen = state.partner.user.hochladen.filter(photo => photo._id !== action.payload);
        },
         addCommentForAccident(state, action){
            state.lastAccident.notes.unshift(action.payload); // Add to the beginning of the array
          },
          addCommentForPartner(state, action){
            state.partner.user.notes.unshift(action.payload); // Add to the beginning of the array
          },
          updateCommentInPartner(state, action) {
            const { id, text, title } = action.payload;
            console.log(id, text, title);
            state.partner.user.notes = state.partner.user.notes.map(note =>
                note._id === id ? { ...note, text, title } : note
            );
        },
          removeCommentForAccident (state, action)  {
            state.lastAccident.notes = state.lastAccident.notes.filter(note => note._id !== action.payload );
          },
          removeCommentForPartner (state, action)  {
    state.partner.user.notes = state.partner.user.notes.filter(note => note._id !== action.payload);
},
          updateCommentInAccident(state, action) {
            const { id, text } = action.payload; // Assuming action.payload contains { id, text }
            console.log(id, text);
            
            const noteToUpdate = state.lastAccident.notes.find(note => note._id === id);
            if (noteToUpdate) {
                noteToUpdate.text = text; // Update the text of the found note
            }
        },
        removePhotoFromLastAccident(state, action) {
            state.lastAccident.photos = state.lastAccident.photos.filter(photo => photo._id !== action.payload);
        },
    }
});
const accidentReducer = accidentSlice.reducer;
const accidentAction = accidentSlice.actions;
export { accidentAction, accidentReducer};